import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`data`}</strong><br />{`Array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`It expects data to be a 2-dimensional array of data.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`accessor`}</strong><br />{`function`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`How to determine how to color each cell. The inputs of the function are:`}<br />{`cell (content of the cell), x , y. The output is: a color. The default value is:`}<br /><inlineCode parentName="td">{`cell => cell ? 0 : 'none' : '#000'`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`size`}</strong><br />{`string/integer, default: 12`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`How big the squares will be in pixels.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`cellProps`}</strong><br />{`anything`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Any extra prop to pass to each individual square`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Any other prop will be passed to the Grid.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      